import * as Yup from "yup";

import { FormHelper, ProductHelper, ValidationHelper } from ".";
import { sourceOptions } from "../product/constants";

const AlertFields = {
  required: ["sources"],
  optional: [
    "reference_number",
    "min_price",
    "max_price",
    "years",
    "conditions",
    "delivery_sets",
    "regions",
    "seller_types",
    "keywords",
    "alert",
    "underpriced",
    "is_not_product",
    "is_only_brand",
  ],
};

const AlertHelper = {
  // Alert.years is an unordered array of individual year values (e.g. a
  // multi-select of [2021, 2019, 2020]). The card/row shows it as a single
  // year when there's only one, or a "min - max" range otherwise — extracted
  // from AlertItem's inline useMemo so it's independently testable and shared
  // between the legacy row and RCAlertCard.
  getYearRangeLabel: (years) => {
    if (!years || years.length === 0) return null;

    const sortedYears = [...years].sort((a, b) => a - b);

    if (sortedYears.length === 1) {
      return `${sortedYears[0]}`;
    }

    return `${sortedYears[0]} - ${sortedYears[sortedYears.length - 1]}`;
  },

  getInitialValues: (listing) => {
    const initialValues = { ...listing };
    initialValues.sources = listing?.sources?.length
      ? listing.sources
      : sourceOptions.map((opt) => opt.id);

    initialValues.product = ProductHelper.getInitialValues(listing?.product);

    return initialValues;
  },

  getValidationSchema: (listing, categoryId) => {
    const validationRules = ValidationHelper.requiredRules(
      AlertFields.required
    );

    return Yup.object(validationRules);
  },

  processSubmitValues: (values) => ({
    ...values,
    alert: values.alert ? values.alert : false,
    underpriced: values.underpriced ? values.underpriced : false,
    is_not_product: values.is_not_product ? values.is_not_product : false,
    is_only_brand: values.is_only_brand ? values.is_only_brand : false,
  }),
};

export default AlertHelper;
